import type { StandingOrders } from './StandingOrders';

export const AT: Partial<StandingOrders> = {
    showReceiverNameFirst: true,
    daysFromTodayOutsideRange: 1,
    standingOrderIntervals: [
        'WEEKLY',
        'MONTHLY',
        'QUARTERLY',
        'SEMI_ANNUAL',
        'ANNUALLY',
        'IRREGULAR',
    ],
    sweepOrderIntervals: ['WEEKLY', 'MONTHLY', 'QUARTERLY', 'SEMI_ANNUAL', 'ANNUALLY', 'IRREGULAR'],
    invalidateCacheAfterMutation: true,
    disableReceiverChangeOnEdit: false,
};
